<template>
    <v-app-bar fixed color="primary" hide-on-scroll app tile flat class="bottom-bordered" scroll-threshold="10" dense>
        <v-app-bar-nav-icon @click="$router.go(-1)">
            <v-icon large>mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title v-if="toolbarTitle">{{toolbarTitle}}</v-toolbar-title>
    </v-app-bar>
</template>
<script>
export default {
    props: ['toolbarTitle']
}
</script>